export default __webpack_public_path__ + "static/media/all-virtual-depoiments-bg.2c37f914.png";